import React, { useContext, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWallet } from "@fortawesome/free-solid-svg-icons";
import { AuthContext } from "../AuthContext";
import s from "../styles/PaymentWalletInfo.module.css";

export default function PaymentWalletInfo({ onBalanceChange }) {
  const { currentUser } = useContext(AuthContext);

  // Передаём баланс наружу, если нужно
  useEffect(() => {
    if (currentUser && onBalanceChange) {
      onBalanceChange(currentUser.balance);
    }
  }, [currentUser, onBalanceChange]);

  // Если пользователь не авторизован
  if (!currentUser) {
    return (
      <div className={s.container}>
        <div className={s.infoText}>
          Ваш баланс: <b>0 р.</b> | Тариф: <b>Без тарифа</b>
        </div>
      </div>
    );
  }

  return (
    <div className={s.container}>
      <div className={s.infoText}>
        <FontAwesomeIcon icon={faWallet} className={s.walletIcon} />
        <span>
          Ваш баланс: <b>{currentUser.balance} р.</b> | Тариф:{" "}
          <b>
            {currentUser.tarif_name || "Без тарифа"}
            {currentUser.tarif_name && ` (${currentUser.days_remaining} дн.)`}
          </b>
        </span>
      </div>
    </div>
  );
}
